import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { pushTag } from "./datalayer";
export const QuickLinks = (p)=>/*#__PURE__*/ _jsxs("nav", {
        className: `quicklinks ${p.className ? p.className : ""}`,
        "aria-label": "Snelkoppelingen",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "quicklinks__title",
                children: p.title
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "quicklinks__list",
                children: p.links.map((c, i)=>/*#__PURE__*/ _jsx("li", {
                        className: "quicklink",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "quicklink__inner",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "",
                                className: "button button--primary quicklink__link",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    pushTag(c.title);
                                    if (c.url.startsWith("#")) p.handleScroll(c.url.substring(1));
                                    else p.handleScroll(c.url);
                                },
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "button__label",
                                    children: c.title
                                })
                            })
                        })
                    }, `group-scroll-${i}`))
            })
        ]
    });
{}